import Component from '../abstracts/Component';
import FiltersComponent from '../components/FiltersComponent';

export default class ShortcutComponent extends Component {

  get SELECTORS() {
    return {
      shortcutItem: '[data-shortcut-item]',
      firstShortcut: '#shortcut_0',
      breadcrumbsWrapper: '.breadcrumbs__wrapper',
    };
  }

  get CLASSES() {
    return {
      selected: '--selected'
    };
  }

  get QUERY_PARAMS() {
    return {
      base: '?save=false&q=:topRated',
      end: ':sortBy:topRated&size=-1', //page size -1 enables the page to hide the infinite page button
    }
  }

  get COMPONENTNAME() {
    return 'ShortcutComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.firstShortcut = this.$component.querySelector(this.SELECTORS.firstShortcut);
    this.shortcutItems = this.$component.querySelectorAll(this.SELECTORS.shortcutItem);

    this.breadcrumbsWrapper = document.querySelector(this.SELECTORS.breadcrumbsWrapper);

    this.FiltersComponent = new FiltersComponent(htmlEl);
  }

  handleFirstShortcutClick() {
    if (this.firstShortcut) {
      this.firstShortcut.addEventListener('click', event => {
        this.firstShortcut.classList.add(this.CLASSES.selected);
        if(this.shortcutItems) {
          this.shortcutItems.forEach(item => { item.classList.remove(this.CLASSES.selected) });
        }
        if (this.firstShortcut.dataset.isLink === "true") {
          window.open(this.firstShortcut.dataset.href, '_self');
        } else {
          this.FiltersComponent.filterQuery(false, '');
          this.hideBreadcrumbs();
          this.toggleFilters(false);
        }
      });
    }
  }

  handleShortcutClick() {
    if(this.shortcutItems) {
      this.shortcutItems.forEach((item) => {
        if (window.location.pathname === item.dataset.href) {
          item.classList.add(this.CLASSES.selected);
        } else {
          item.classList.remove(this.CLASSES.selected);
        }

        item.addEventListener('click', (e) => {
          this.firstShortcut?.classList.remove(this.CLASSES.selected);

          item.classList.add(this.CLASSES.selected);
          this.shortcutItems.forEach((otherEl) => {
            if (otherEl.id !== item.id) {
              otherEl.classList.remove(this.CLASSES.selected);
            }
          });
          //if not link card and sku populated
          if (item.dataset.isLink === 'false' && item.dataset.products) {
            const productsArray = item.dataset.products.split(',');
            let query = this.QUERY_PARAMS.base;
            productsArray.forEach((productCode) => {
              if (productCode.length === 13) {
                query += ':code:' + productCode;
              }
            });
            query += this.QUERY_PARAMS.end;
            this.log('fullQuery ', query);
            this.FiltersComponent.filterQuery(false, query);
            this.showBreadcrumbs(item.dataset.shortcutTitle);
            this.toggleFilters();
          }
          //if link card and href populated
          if (item.dataset.isLink === 'true' && item.dataset.href) {
            window.open(item.dataset.href, '_self');
          }
        });
      });
    }
  }

  showBreadcrumbs(title) {
    if (window.matchMedia('(min-width: 1024px)').matches) {
      this.breadcrumbsWrapper.querySelector('a.shortcut-page').innerHTML = title;
      this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
        el.style.display = 'inline-block';
      });
    }
  }

  hideBreadcrumbs() {
    this.breadcrumbsWrapper.querySelectorAll('.shortcut-page').forEach((el) => {
      el.style.display = 'none';
    });
  }

  toggleFilters(bool = true) {
    if (bool) {
      document.querySelector('.w-f__wrapper').style.visibility = 'hidden';
    } else {
      document.querySelector('.w-f__wrapper').style.visibility = 'visible';
    }
  }

  render() {
    super.render();
    this.handleFirstShortcutClick();
    this.handleShortcutClick();
  }
}
